import defaultSettings from '@/settings'
import i18n from '@/lang'

const title = defaultSettings.title || '培训学习';

export default function getPageTitle(key) {
  const hasKey = i18n.te(`menu.${key}`);
  if (hasKey) {
    const pageName = i18n.t(`menu.${key}`);
    return `${pageName} - ${title}`
  }
  return `${title}`
}



// WEBPACK FOOTER //
// ./src/utils/get-page-title.js